var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?[_c('strong',[_vm._v(_vm._s(_vm.label))]),_c('br')]:_vm._e(),(_vm.value)?[_vm._v(" "+_vm._s(_vm.value)+" "),(_vm.appendText)?[_vm._v(" "+_vm._s(_vm.appendText)+" ")]:_vm._e()]:[_vm._v(" - ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }